import { useEffect } from 'react';

export const useKeyboardShortcuts = (handlers) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Don't trigger if user is typing in an input/textarea
      const activeElement = document.activeElement;
      const isInputFocused = 
        activeElement.tagName === 'INPUT' ||
        activeElement.tagName === 'TEXTAREA' ||
        activeElement.isContentEditable;

      if (isInputFocused) return;

      const { key, shiftKey, metaKey, ctrlKey } = event;

      // Prevent default for our shortcuts
      const shouldPreventDefault = 
        key === ' ' || 
        (key === 'ArrowLeft' && !shiftKey) ||
        (key === 'ArrowRight' && !shiftKey) ||
        key === 'r' ||
        key === 'f' ||
        key === 'Escape';

      if (shouldPreventDefault) {
        event.preventDefault();
      }

      // Space - Play/Pause
      if (key === ' ' && handlers.onPlayPause) {
        handlers.onPlayPause();
      }

      // Arrow Left - Previous (Ayah or Surah)
      else if (key === 'ArrowLeft' && !shiftKey && handlers.onPrevious) {
        handlers.onPrevious();
      }

      // Arrow Right - Next (Ayah or Surah)
      else if (key === 'ArrowRight' && !shiftKey && handlers.onNext) {
        handlers.onNext();
      }

      // Shift + Arrow Left - Previous Surah
      else if (key === 'ArrowLeft' && shiftKey && handlers.onPreviousSurah) {
        handlers.onPreviousSurah();
      }

      // Shift + Arrow Right - Next Surah
      else if (key === 'ArrowRight' && shiftKey && handlers.onNextSurah) {
        handlers.onNextSurah();
      }

      // R - Toggle Repeat
      else if (key === 'r' && !metaKey && !ctrlKey && handlers.onToggleRepeat) {
        handlers.onToggleRepeat();
      }

      // F - Focus Mode
      else if (key === 'f' && !metaKey && !ctrlKey && handlers.onFocusMode) {
        handlers.onFocusMode();
      }

      // Escape - Exit Focus / Collapse Player
      else if (key === 'Escape' && handlers.onEscape) {
        handlers.onEscape();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handlers]);
};

